import React, { useEffect, useRef } from 'react'
import * as echarts from 'echarts'
import echartsTheme from '../echartsTheme' // 引入自定义主题文件
import { useTranslation } from 'react-i18next'

interface EChartComponentProps {
  staticOption: echarts.EChartsOption // ECharts 配置项
  dynamicOption?: echarts.EChartsOption
  onChartInit?: (chartInstance: echarts.ECharts) => void // 回调函数，传递图表实例
}

const EChartComponent: React.FC<EChartComponentProps> = React.memo(({ staticOption, dynamicOption, onChartInit }) => {
  const { t } = useTranslation()
  const chartRef = useRef<HTMLDivElement>(null)
  const chartInstance = useRef<any>(null)

  useEffect(() => {
    echarts.registerTheme('customTheme', echartsTheme)
    if (chartRef.current) {
      chartInstance.current = echarts.init(chartRef.current, 'customTheme')
      chartInstance.current.setOption(staticOption, true)
      // 调用回调函数传递图表实例
      if (onChartInit) {
        onChartInit(chartInstance.current)
      }
      return () => {
        chartInstance.current.dispose()
      }
    }
  }, [staticOption, t])

  useEffect(() => {
    if (dynamicOption && chartInstance.current) {
      chartInstance.current.setOption(dynamicOption)
    }
  }, [dynamicOption])

  return <div className='echart-container' ref={chartRef} />
})

export default EChartComponent
